/* eslint-disable check-file/filename-blocklist */
export const mapV1UrltoV2 = (url, query, spaceKey) => {
	if (!/.*\/viewpreviousversions\.action/.test(url)) {
		return {
			url,
			query,
		};
	}
	const newQuery = {
		...query,
	};
	delete newQuery.pageId;

	return {
		url: `/wiki/spaces/${spaceKey}/history/${query.pageId}`,
		query: newQuery,
	};
};

export const queryMatcher = ({ createDialog }) => ['true', 'close'].includes(createDialog);
